import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon, ChartBarIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-900 px-4">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center max-w-md"
    >
      <h1 className="text-7xl font-display font-bold bg-gradient-to-r from-pink-500 to-violet-600 bg-clip-text text-transparent">404</h1>
      <h2 className="mt-4 text-2xl font-semibold text-gray-900 dark:text-white">Page Not Found</h2>
      <p className="mt-2 text-gray-500 dark:text-gray-400">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-pink-500 to-violet-600 hover:from-pink-600 hover:to-violet-700 text-white font-medium shadow-md transition-colors"
        >
          <HomeIcon className="w-5 h-5" />
          Go Home
        </Link>
        <Link
          to="/dashboard"
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gray-100 dark:bg-dark-800 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-200 dark:hover:bg-dark-700 transition-colors"
        >
          <ChartBarIcon className="w-5 h-5" />
          Dashboard
        </Link>
        <Link
          to="/help"
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gray-100 dark:bg-dark-800 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-200 dark:hover:bg-dark-700 transition-colors"
        >
          <QuestionMarkCircleIcon className="w-5 h-5" />
          Help
        </Link>
      </div>
    </motion.div>
  </div>
);

export default NotFoundPage;
